/* eslint-disable jsx-a11y/iframe-has-title */
import MobileMenuPanel from "./MobileMenuPanel";
import {
  CURRENT_PURPOSE,
  WEBSITE_REAL_ESTATE,
} from "../configs/website-config";
import MobileSecondFooter from "./MobileSecondFooter";
import MobileFooter from "./MobileFooter";
import { LoginModal } from "./LoginModal";
import { useState } from "react";
import ProductCertificate from "./ProductCertificate";
import { useDispatch } from "react-redux";
import { useIntl } from "react-intl";
import { getFetchLedgerLot, getFetchLedgerLotHistory } from "../Redux/products/slice";
import { TextInput, Button as MantineButton, Text, Title } from "@mantine/core";
import { FaSearch } from "react-icons/fa";
import ContentCopy from "@mui/icons-material/ContentCopy";
import { FormattedMessage } from "react-intl";
import CertificatePage from "./CertificatePage";
import styled from 'styled-components';

const backgroundImage =
  CURRENT_PURPOSE === WEBSITE_REAL_ESTATE
    ? "../assets/bg.jpeg"
    : "../assets/summer.png";

const style = {
  papaerStyle: {
    height: "100%",
    width: "100%",
    backgroundImage: "url('" + backgroundImage + "')",
  },
  gridStyle: {
    width: "100%",
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "flex-start",
    backgroundColor: "rgb(122 139 164 / 75%)",
  },
  menuBar: {
    // height: "120px",
    width: "100%",
    opacity: 1,
  },
  whole: {
    // width: "100%",
    // position: "fixed",
    justifyContent: "center",
  },
  iframe: {
    width: "100%",
    height: `calc(100vh - 100px)`
  },
  explorer: {
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
    padding: '5px', // Adjust padding as needed
    boxSizing: 'border-box', // Include padding in total width
  },
  text: {
    fontFamily: 'Montserrat, sans-serif',
    marginTop: '40px',
    marginBottom: '40px',
    merginLeft: '10px',
    merginRight: '10px',
    padding: '10px',
    textAlign: 'center', // Center-align the text
    overflowY: "auto", 
    width: '100%',
  },
  container: {
    width: '100%',
    maxWidth: '1200px',
    margin: 'auto',
    boxSizing: 'border-box', // Ensuring padding doesn't increase the total width
    overflowY: "auto", 
  },
};

const TransactionExplorer = () => {
  const [inputValue, setInputValue] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();
  const intl = useIntl();

  const handleSearch = async () => {
    if (!inputValue) return;
    
    setIsLoading(true);
    try {
      await dispatch(getFetchLedgerLot({ inputValue: String(inputValue) }));
      await dispatch(getFetchLedgerLotHistory({ inputValue: String(inputValue) }));      
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleCopyLink = () => {
    const certificateLink = `${window.location.origin}/certificate/${inputValue}`;
    navigator.clipboard.writeText(certificateLink);
  };

  const TitleDescriptionWrapper = styled.div`
    font-family: 'Montserrat, sans-serif';
  `;

  return (
    <>
      <div className="whole" style={style.whole}>
        <MobileMenuPanel level={1}/>
        <div className="ex" style={{ ...style.explorer, display: "flex", justifyContent: "center", alignItems: "center" }}>
          <div style={style.container}>
            <TitleDescriptionWrapper style={{marginTop: "40px", marginBottom: "40px" }}>
              <Title order={3} weight={200} align="center" style={{ fontFamily: 'Montserrat, sans-serif'}}>
                <FormattedMessage id="explorer.title" />
              </Title>
              <Text style={style.text}>
                <FormattedMessage id="explorer.text" />
              </Text>
            </TitleDescriptionWrapper>
            <div className="ex" style={{ ...style.explorer, display: "flex", justifyContent: "center", alignItems: "center" }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '10px', maxWidth: '400px', margin: '10px'}}>
                <TextInput
                  placeholder={intl.formatMessage({ id: "explorer.search.placeholder" })}
                  value={inputValue}
                  onChange={(e) => setInputValue(e.target.value)}
                />
                {/* <MantineButton variant="outline" onClick={handleSearch} loading={isLoading}>
                  <FaSearch />
                </MantineButton> */}
                <MantineButton 
                  variant="outline" 
                  startIcon={<ContentCopy />}
                  onClick={() => handleCopyLink(inputValue)}
                >
                  <FormattedMessage id="button.dload.pdf" />
                </MantineButton>
              </div>
            </div>
            <div style={{ width: '100%' }}>
              {inputValue && <CertificatePage productId={inputValue} fromExplorer={true} />}
            </div>
          </div>
        </div>
        <MobileSecondFooter />
        <MobileFooter />
      </div>
      <LoginModal/>
    </>
  );
};

export default TransactionExplorer;
